module.exports = __webpack_public_path__ + "static/media/trash-red.39f00141.svg";